
// @ts-nocheck


import { LoyaltyCertTypesMix } from "@/UI/mixins/Loaylty/LoyaltyCertTypesMix";
import { Component, Vue } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import LoyaltyCertTypeAddComponent from "@/UI/components/forms/loyalty/loyaltyCert/loyaltyCertType/LoyaltyCertTypeAddComponent.vue";
import LoyaltyCertTypeUpdateComponent from "@/UI/components/forms/loyalty/loyaltyCert/loyaltyCertType/LoyaltyCertTypeUpdateComponent.vue";
import { mixins } from "vue-class-component";
import moment from "moment";
import { Button, Menu, List, Table, Select, Input, Tabs, FormModel, Modal } from "ant-design-vue";
import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { RouterNameEnum } from "@/router/router.types";
import { getStudioId } from "@/UI/lib/state";
import { TableColumns } from "@/UI/pages/loyalty/lib/table"
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {LoyaltyCertRepository} from "@/repository/loyalty/Cert/LoyaltyCertRepository"
import { SalonsRepository } from "@/repository/salons/SalonsRepository.ts";
import {getStudioId} from "@/UI/lib/state";
import {appPaginationStore} from "@/store/modules/appPagination";
import {ProxyGetData} from "@/UI/components/Helpers/getData";

@Component({
    components: {
        PageTitle,
        LoyaltyCertTypeAddComponent,
        LoyaltyCertTypeUpdateComponent,
        BaseDataForm,
        "a-button": Button,
        "a-menu-item": Menu.Item,
        "a-list-item": List.Item,
        "a-list-item-meta": List.Item.Meta,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-table": Table,
        "a-input": Input,
        "a-tab": Tabs,
        "a-tab-pane": Tabs.TabPane,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
        "a-modal": Modal,
        SortComponent
    },
    methods: { moment },
})

export default class LoyaltyCertType extends mixins(
    ProxyGetData,
    ProxyTableData,
    LoyaltyCertTypesMix,
    TableColumns,
) {
    async created(): Promise<void> {

        (new LoyaltyCertRepository).fetchAll().then(answer=> {
            console.log('++++++++++++++++++++1676980154++++++++++++++++++++++++');console.log('answer : ' + (typeof answer));console.log(answer);console.log('--------------------1676980154------------------------');

        })
        try {
            this.tableLoad = false;
            this.formReady = false;
            this.proxyFilter = {
                salon_id: getStudioId(this)
            }
            appPaginationStore.setCurrent(1)
            await this.createProxy();


            // ----- adding currency string (Starting line.) -----
            // ----- currencyIdOfThisStudio (Starting line.) -----
            var currencyIdOfThisStudio;
            var currencyOfThisStudioString;
            console.log('in1678651121');
            var response = await (new SalonsRepository).fetchAll({limit: -1});
            let thisStudioId = getStudioId(this);
            let thisStudio = response.data.filter(studio => {
                if (thisStudioId == studio.id) return true;
                return false;
            })[0];
            currencyIdOfThisStudio = thisStudio.currency_id;
            console.log('++++++++++++++++++++1676990441++++++++++++++++++++++++');console.log('currencyIdOfThisStudio : ' + (typeof currencyIdOfThisStudio));console.log(currencyIdOfThisStudio);console.log('--------------------1676990441------------------------');

            // ----- decypher currency id (Starting line.) -----
            if (currencyIdOfThisStudio == 1) { currencyOfThisStudioString = 'RUB'; }    
            if (currencyIdOfThisStudio == 2) { currencyOfThisStudioString = 'USD'; }    
            if (currencyIdOfThisStudio == 3) { currencyOfThisStudioString = 'EUR'; }    
            // ----- decypher currency id (Ending line.) -----
            // ----- currencyIdOfThisStudio (Ending line.) -----

            this.loyaltyCertTypes.data.forEach((element) => {
                if (!element.balance.toString().match(new RegExp(' ' + currencyOfThisStudioString + '$', 'gmi'))) {
                    element.balance = (element.balance.toString().replace(/\..+$/gmi, '') + ' ' + currencyOfThisStudioString)
                }
            });
            // ----- adding currency string (Ending line.) -----

        } catch (e) {
            console.error(e)
        } finally {
            this.formReady = true;
            this.tableLoad = true;
        }
    }

    certTypeLink(record:any): any {
        return {
            name:this.$routeRules.LoyaltyCertTypeGet,
            params:{Studio: getStudioId(this), id:record['id']}
        }
    }

    AddCertType(): void {
        Vue.router.push({
            name: RouterNameEnum.LoyaltyCertTypeAdd,
            params: {
                Studio: getStudioId(this),
            },
        });
    }

    async setFilter({by, sort}): void {
        await this.sortedData(by, {dataIndex: sort.dataIndex})
    }
}
